import React from 'react';
var AKBadge = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.badge' */
  '@atlaskit/badge');
});
function Badge(_ref) {
  var _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance,
    text = _ref.text;
  return /*#__PURE__*/React.createElement(AKBadge, {
    appearance: appearance
  }, text);
}
export default Badge;
export function BadgeFn(_ref2) {
  var props = _ref2.props;
  var _ref3 = props,
    appearance = _ref3.appearance,
    text = _ref3.text;
  return /*#__PURE__*/React.createElement(Badge, {
    appearance: appearance,
    text: text
  });
}